import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, ChevronDown, Mail } from "lucide-react";
import { api, errText } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Switch } from "../../components/ui/switch";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../components/ui/dropdown-menu";

const copyText = async (text) => {
  try { await navigator.clipboard.writeText(text); return true; } catch {
    const ta = Object.assign(document.createElement("textarea"), { value: text });
    document.body.appendChild(ta); ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    return ok;
  }
};

export const CopyEmails = ({ rows, label }) => {
  const emails = rows.map((r) => r.email);
  const copy = async (sep, kind) => {
    if (await copyText(emails.join(sep))) toast.success(`Copied ${emails.length}${label ? ` ${label}` : ""} email${emails.length === 1 ? "" : "s"} (${kind})`);
    else toast.error("Couldn't copy — try the CSV download");
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={!emails.length} className="rounded-xl gap-1.5" data-testid="sub-copy">
          <Copy size={15} /> Copy emails ({emails.length}) <ChevronDown size={14} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => copy(", ", "comma-separated")} data-testid="sub-copy-comma">Comma-separated — for an email's To / BCC</DropdownMenuItem>
        <DropdownMenuItem onClick={() => copy("\n", "one per line")} data-testid="sub-copy-lines">One per line — for spreadsheets</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const FooterNewsletterToggle = () => {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/site/footer-newsletter").then(({ data }) => setOn(data.enabled)).catch(() => {}); }, []);
  const change = async (v) => {
    setOn(v);
    try { await api.put("/admin/site/footer-newsletter", { enabled: v }); toast.success(v ? "Footer sign-up box is on" : "Footer sign-up box is off"); }
    catch (e) { setOn(!v); toast.error(errText(e)); }
  };
  if (on === null) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 p-4 flex items-center gap-3" data-testid="footer-newsletter-toggle">
      <span className="h-10 w-10 rounded-xl bg-[#FFF4F0] flex items-center justify-center"><Mail size={18} className="text-[#F5551E]" /></span>
      <div className="flex-1">
        <p className="text-sm font-semibold text-[#12234A]">Newsletter box in the site footer</p>
        <p className="text-xs text-slate-400">Visitors can join the newsletter from the bottom of every page. New members can also tick a box when signing up.</p>
      </div>
      <Switch checked={on} onCheckedChange={change} data-testid="footer-newsletter-switch" />
    </div>
  );
};
